import React from 'react';

import { Helpers } from '../../core/src/helpers';
import { getIcon, isImageSrc, isSVG } from '../../category-landing-page/components/shared';

const DynamicIcon = ({ icon, size = 'l', category, className, alt }) => {
    if (!icon) return null;

    const ariaProps = alt ? { role: 'img', 'aria-label': alt } : { 'aria-hidden': 'true' };

    if (isImageSrc(icon)) {
        return <img src={icon} className={className} alt={alt || ''} {...ariaProps} />;
    }

    if (isSVG(icon)) {
        return (
            <span
                className={`svg-icon ${className || ''}`}
                dangerouslySetInnerHTML={Helpers.createMarkup(icon)}
                {...ariaProps}
            />
        );
    }

    if (typeof icon === 'string') {
        const mappedIcon = getIcon(icon, category, size);
        if (!mappedIcon) return null;

        if (!className) {
            return mappedIcon;
        }

        return (
            <span className={className} {...ariaProps}>
                {mappedIcon}
            </span>
        );
    }

    return icon;
};

export default DynamicIcon;
